import { connect } from 'react-redux';
import { decorateWith } from 'helpers/decorator';
import { selectResultsLayout, selectTotalHitsInLayout } from 'features/Search/Search.helpers';
import { VenueSupply } from './VenueSupply';

export const MIN_VENUES_TO_DISPLAY_VENUE_SUPPLY_MODULE = 100;

export const mapStateToProps = state => {
  const { data: searchData, loaded } = selectResultsLayout(state);
  const totalResults = selectTotalHitsInLayout(searchData);
  const shouldRender = !loaded || (loaded && totalResults >= MIN_VENUES_TO_DISPLAY_VENUE_SUPPLY_MODULE);
  return {
    shouldHide: !shouldRender,
  };
};

export const VenueSupplyContainer = decorateWith(connect(mapStateToProps))(VenueSupply);
